import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputFieldUI from '../../../widgets/form/InputFieldUI'
import './MonitoringActionModalUI.css'

const MonitoringActionModalUI = ({
  context,
  isUpdateMode,
  onCancelClick,
  onSubmit,
  successMsg,
  errorList,
  setErrorList,
  selectedAction,
  onActionChange,
  actionError,
  selectedComment,
  onCommentChange,
  commentError,
  currentItem,
  actionOptions,
  showActionField,
  showCommentField
}) => {
  return (
    <ModalFormUI
      context={context}
      titleLabel={`Update Monitoring Information - ${(currentItem && currentItem.lrn) || ''}`}
      buttonLabel='Submit'
      cancelLabel='Cancel'
      isOpen={isUpdateMode}
      onRequestClose={onCancelClick}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      onSubmit={onSubmit}
    >
      {showActionField && (
        <InputSelectSF
          name='monitoringAction'
          label='Monitoring Action'
          value={selectedAction}
          onChange={onActionChange}
          optionList={actionOptions}
          error={actionError}
        />
      )}

      {showCommentField && (
        <InputFieldUI
          name='monitoringComment'
          label='Monitoring Comment'
          error={commentError}
        >
          <textarea
            name='monitoringComment'
            value={selectedComment}
            onChange={onCommentChange}
            rows={5}
            className={`monitoringCommentTextarea ${commentError ? 'hasError' : ''}`}
          />
        </InputFieldUI>
      )}
    </ModalFormUI>
  )
}

export default MonitoringActionModalUI